export default "__VITE_ASSET__DozMpd9y__"